// /IPORequest/CreateUserIPORequest/{nationalCode}

import AxiosCustom from "../../components/common/apiConfigPouyan/index";

export function apiCreateUserIPORequest(payload) {

  const config = {

    url: `/IPORequest/CreateUserIPORequest/${payload?.data?.nationalCode}`,
    // method:'GET'
  };

  const data = payload?.data?.body

  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
